export default __webpack_public_path__ + "static/media/bingo.1a0278ca.svg";